import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IModifiersFeature } from './modifiers.feature.state';
import { getFailures, getIsLoading, getModifiers } from './modifiers.selectors';

@Injectable()
export class ModifiersFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public modifiers$ = this.store.select(getModifiers);

  constructor(private store: Store<IModifiersFeature>) {}
}
